/* global axios */
import ApiClient from '../ApiClient';

class AnalysisCriteria extends ApiClient {
  constructor() {
    super('analysis/criteria', { accountScoped: true });
  }

  get({ page = 1, activeOnly = false } = {}) {
    return axios.get(this.url, { params: { page, active_only: activeOnly } });
  }

  create(data = {}) {
    return axios.post(this.url, { criterion: data });
  }

  update(id, data = {}) {
    return axios.put(`${this.url}/${id}`, { criterion: data });
  }
}

export default new AnalysisCriteria();
